$(do->
	conf          = window.conf
	mishoryuClass = conf.class
	breakEvent    = new mishoryuClass.BreakEvent()
	resizeEvent   = new mishoryuClass.ResizeEvent()

	# //////////////////////////////////////////////////////////////////////////
	#
	# スライダー
	#
	# //////////////////////////////////////////////////////////////////////////
	slider               = false
	sliderFadeSpeed      = 250
	slideSpeed           = 500
	sliderModalActive    = false
	sliderFire           = false
	type                 = null
	bxSliderPrevSelector = '.bx-controls-direction .bx-prev'
	bxSliderNextSelector = '.bx-controls-direction .bx-next'
	$trigger             = $('.page__gallery li a')
	$sliderRoot          = $('.page__gallery-slider')
	$sliderCnt           = $('.slider-cnt', $sliderRoot)   # コントローラーとか、テキストも込み
	$sliderSet           = $('.set > div', $sliderCnt)     # スライダーだけ
	$sliderText          = $('> .text', $sliderCnt)        #
	$sliderPrevBtn       = $('.ctrl .prev a', $sliderRoot) # prevボタン
	$sliderNextBtn       = $('.ctrl .next a', $sliderRoot) # nextボタン
	$closeBtn            = $('.close-btn', $sliderRoot)
	sliderConf           = {}
	selectedSliderConf   = null
	# --------------------------------------------------------------------------
	# 画面幅関係なく適用するスライダパラメータ
	# --------------------------------------------------------------------------
	sliderConf.common =
		'onSliderLoad' : (currentIndex)->
			sliderCtrl.setText(currentIndex + 1)
			return
		'onSlideBefore' : ($elm, oldIndex, newIndex)->
			sliderCtrl.setText(newIndex + 1)
			sliderFire = true
			return
		'onSlideAfter' : ()->
			sliderFire = false
			return
	# --------------------------------------------------------------------------
	# 画面が小さいときのスライダパラメータ
	# --------------------------------------------------------------------------
	sliderConf.small = $.extend({
		'infiniteLoop'        : true
		'responsive'          : true
		'auto'                : false
		'pager'               : false
		'speed'               : slideSpeed
		'adaptiveHeight'      : false
		'touchEnabled'        : true
		# 'adaptiveHeightSpeed' : sliderFadeSpeed
	}, sliderConf.common)
	# --------------------------------------------------------------------------
	# 画面が大きいときのスライダパラメータ
	# --------------------------------------------------------------------------
	sliderConf.large = $.extend({
		'infiniteLoop'        : true
		'responsive'          : false
		'auto'                : false
		'pager'               : false
		'touchEnabled'        : false
		'adaptiveHeight'      : false
		'speed'               : slideSpeed
	}, sliderConf.common)
	# ==========================================================================
	# スライダーの処理
	# ==========================================================================
	sliderCtrl =
		# ----------------------------------------------------------------------
		# スライダー破壊
		# ----------------------------------------------------------------------
		'destroy' : (callback)->
			$sliderSet.removeClass('active')
			if slider
				slider.destroySlider()
				slider = undefined
			if callback then callback()
			return @
		# ----------------------------------------------------------------------
		# スライダー登録
		# ----------------------------------------------------------------------
		'setup' : (index, callback)->
			$parent = $($sliderSet[index])
			$parent.addClass('active')
			slider  = $('> ul', $parent).bxSlider(selectedSliderConf)
			if callback then callback()
			return @
		# ----------------------------------------------------------------------
		# スライダー変更
		# ----------------------------------------------------------------------
		'change' : (index = 0, callback)->
			@destroy().setup(index)
			if callback then callback()
			return @
		# ----------------------------------------------------------------------
		# タイトルとキャプションの設定
		# ----------------------------------------------------------------------
		'setText' : (index, callback)->
			_$img    = $('.set .active li[data-num="'+index+'"] img', $sliderCnt)
			_$img    = $(_$img[0])
			_title   = _$img.data('title')
			_caption = _$img.data('caption')
			$sliderText.empty()
			$sliderText.append('<h1>'+_title+'</h1>')
			$sliderText.append('<div><p>'+_caption+'</p></div>')
			# $('h1', $sliderText).html(_title)
			# $('div p', $sliderText).html(_caption)
			return @
	# ==========================================================================
	# モーダルの表示 / 非表示
	# ==========================================================================
	showSliderModal = (callback)->
		$sliderRoot.stop().fadeIn(sliderFadeSpeed, ()->
			sliderModalActive = true
			if callback then callback()
			return
		)
		return
	hideSliderModal = (callback)->
		$sliderRoot.stop().fadeOut(sliderFadeSpeed, ()->
			sliderModalActive = false
			if callback then callback()
			return
		)

	# ==========================================================================
	# 動作設定
	# ==========================================================================
	# if !conf.helper.ua.isMobile() then return
	# --------------------------------------------------------------------------
	# サムネイルクリック
	# --------------------------------------------------------------------------
	$trigger.on('click', (e)->
		_$this = $(this)
		e.preventDefault()
		showSliderModal()
		sliderCtrl.change(_$this.parents('li').index())
		return
	)
	# --------------------------------------------------------------------------
	# クローズボタンやモーダル背景クリック
	# --------------------------------------------------------------------------
	$closeBtn.on('click', (e)->
		e.preventDefault()
		e.stopPropagation()
		hideSliderModal(sliderCtrl.destroy)
		return
	)
	$sliderCnt.on('click', (e)->
		e.preventDefault()
		e.stopPropagation()
		if $(e.target).attr('class') is $sliderCnt.attr('class')
			hideSliderModal(sliderCtrl.destroy)
		return
	)
	$('.gallery-wapper', $sliderRoot).on('click', (e)->
		e.preventDefault()
		e.stopPropagation()
		if $(e.target).attr('class') is 'gallery-wapper'
			hideSliderModal(sliderCtrl.destroy)
		return
	)
	breakEvent.addListener('iemoto-slider', (type)->
		selectedSliderConf = if type is 'small' then sliderConf.small else sliderConf.large
		if sliderModalActive then $closeBtn.trigger('click')
		return
	)
	# --------------------------------------------------------------------------
	# スライダーコントローラー
	# --------------------------------------------------------------------------
	$sliderPrevBtn.on('click', (e)->
		e.preventDefault()
		e.stopPropagation()
		if sliderFire then return
		$(bxSliderPrevSelector, $sliderSet).trigger('click')
		return
	)
	$sliderNextBtn.on('click', (e)->
		e.preventDefault()
		e.stopPropagation()
		if sliderFire then return
		$(bxSliderNextSelector, $sliderSet).trigger('click')
		return
	)
	# --------------------------------------------------------------------------
	# リサイズイベント
	# --------------------------------------------------------------------------
	breakEvent.addListener('iemoto-slider-resize', (_type)->
		type = _type;
		return
	)
	# サイズの調整
	resizeEvent.addListener('click', (e, param)->
		if !type then return
		if type is 'small'
			_offset = 20 # 左右のマージン
			_h      = param.windowWidth - _offset # 正方形
			$sliderSet.css('height', _h)
		else
			# $sliderSet.css('height', $sliderCnt.height())
			$sliderSet.css('height', '')
		return
	)

	return
)
